import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from 'element-ui/lib/locale/lang/en'
import i18n from 'src/lang'

Vue.use(ElementUI, { size: 'mini', i18n: (key, value) => i18n.t(key, value) })


// WEBPACK FOOTER //
// ./src/plugins/element-ui.js